"use strict";
/* eslint-disable @typescript-eslint/no-misused-promises*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Container_1 = __importDefault(require("@mui/material/Container"));
var styles_1 = require("@mui/material/styles");
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var theme_1 = __importDefault(require("../public/themes/theme"));
var AxiosClient_1 = require("../utils/AxiosClient");
var react_hook_form_1 = require("react-hook-form");
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var axios_1 = __importDefault(require("axios"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var theme = theme_1.default;
function SignIn() {
    var _a = (0, react_hook_form_1.useForm)(), register = _a.register, handleSubmit = _a.handleSubmit, errors = _a.formState.errors;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var tsver = Boolean(js_cookie_1.default.get("tsver"));
    var onSubmit = handleSubmit(function (data) {
        react_hot_toast_1.default.loading("Please wait ....");
        setLoading(true);
        AxiosClient_1.AxiosClient.post("/login", {
            email: data.email,
            password: data.password,
        })
            .then(function (response) {
            react_hot_toast_1.default.remove();
            react_hot_toast_1.default.success(response.data.message);
            var token = response.data.token;
            var userId = response.data.userId; // retrieve userId from response
            var role = response.data.role; // retrieve role from response
            localStorage.setItem("userId", userId); // store userId in localStorage
            localStorage.setItem("role", role); // store role in localStorage
            axios_1.default.defaults.headers.common["Authorization"] = "Bearer ".concat(token);
            js_cookie_1.default.set("token", token);
            localStorage.setItem("phnbr", response.data.phone);
            js_cookie_1.default.set("role", response.data.role);
            if (response.data.role == "seller") {
                if (tsver) {
                    window.location.href = "/seller-home";
                }
                else {
                    window.location.href = "/verify-code";
                }
            }
            else if (response.data.role == "user" ||
                response.data.role == "buyer") {
                window.location.href = "/";
            }
            else {
                window.location.href = "/admin-dashboard";
            }
        })
            .catch(function (error) {
            react_hot_toast_1.default.remove();
            setLoading(false);
            console.log(error);
            react_hot_toast_1.default.error(error.response.data.message);
        });
    });
    return (React.createElement(styles_1.ThemeProvider, { theme: theme },
        React.createElement(Container_1.default, { component: "main", maxWidth: "xs" },
            React.createElement(CssBaseline_1.default, null),
            React.createElement(Box_1.default, { sx: {
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flexWrap: "wrap",
                    "& > :not(style)": {
                        m: 1,
                        paddingTop: 6,
                        paddingLeft: 5,
                        paddingRight: 5,
                    },
                } },
                React.createElement(Paper_1.default, { elevation: 3, sx: {
                        p: 4,
                        margin: "50px auto",
                        maxWidth: 450,
                        flexGrow: 1,
                    } },
                    React.createElement(Typography_1.default, { component: "h1", variant: "h5" }, "Sign in"),
                    React.createElement(Link_1.default, { href: "/", variant: "body2" }, "Home"),
                    React.createElement(Box_1.default, { component: "form", onSubmit: onSubmit, noValidate: true, sx: { mt: 1 } },
                        React.createElement(TextField_1.default, __assign({}, register("email", { required: true }), { margin: "normal", fullWidth: true, label: "Email Address", autoComplete: "off", error: !!errors.email, helperText: errors.email ? "Email is required" : "" })),
                        React.createElement(TextField_1.default, __assign({}, register("password", { required: true }), { margin: "normal", fullWidth: true, label: "Password", type: "password", id: "password", autoComplete: "off", error: !!errors.password, helperText: errors.password ? "Password is required" : "" })),
                        React.createElement(Grid_1.default, { container: true },
                            React.createElement(Grid_1.default, { item: true, xs: true },
                                React.createElement(Link_1.default, { href: "/reset-password", variant: "body2" }, "Forgot password?"))),
                        React.createElement(Button_1.default, { type: "submit", fullWidth: true, disabled: loading, variant: "contained", sx: { mt: 3, mb: 2 } }, "Sign In"),
                        React.createElement(Grid_1.default, { container: true },
                            React.createElement(Grid_1.default, { item: true },
                                React.createElement(Link_1.default, { href: "/signup", variant: "body2" }, "Don't have an account? Sign Up"))))))),
        React.createElement(react_hot_toast_1.Toaster, null)));
}
exports.default = SignIn;
